import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { Spin, Row, Col, Button, Select, Tooltip, Modal, Checkbox, message } from 'antd';
import { FileAddOutlined, DeleteOutlined } from '@ant-design/icons';
import { find } from 'lodash';

import {
    loadMyReports,
    createNewReport,
    setSelectedYear,
    deleteReport,
    uploadReportFile,
    submitNewReportForApproval
} from '../actions';
import * as constants from '../constants';

import NewReportForm from './NewReportForm';

import uistate from '../../uistate';
import common from '../../../common';
import core from '../../core';
import currentuser from '../../currentuser';
import globalappstate from '../../globalappstate';

const { AgGridWithState } = core;
const { RendererBoolean, RendererStatus } = common;

class MyReportsGrid extends Component {

    state = {
        selectedIdReport: 0,
        showall: false,
        currentEditEntity: {},
        addNewReportFormVisible: false,
    }

    constructor(props) {
        super(props);
    }

    UNSAFE_componentWillMount() {
        this.props.loadMyReports(this.props.selectedYear);
    }
    componentWillUnmount() {
        if (this.gridApi) {
            var columnState = this.gridApi.getColumnState()
            var filterModel = this.gridApi.getFilterModel()
            this.props.saveGridFilters('MyReportsGrid', { columnState, filterModel })
        }
    }

    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'MyReportsGrid', key);
    }
    nrFormatter = (params) => {
        if (params.value) {
            return Number(params.value).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2 });
        } else {
            return ''
        }
    }

    refreshClicked = () => {
        this.props.loadMyReports(this.props.selectedYear);
    }

    getGridCols = () => {
        let cols = [
            { key: "status", headerName: this.label("Status"), field: "status", sortable: true, filter: false, enableRowGroup: true, suppressHeaderMenuButton: true, width: 80, minWidth: 80, maxWidth: 80, cellRenderer: 'rendererStatus' },
            { key: "number", width: 110, minWidth: 110, maxWidth: 110, headerName: this.label("Number"), field: "number", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
            { key: "type", width: 70, headerName: this.label("Type"), field: "type", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true },
            { key: "personnelNumber", headerName: this.label("PersonnelNumber"), field: "personnelNumber", sortable: true, filter: false, enableRowGroup: false, suppressHeaderMenuButton: true, width: 100, minWidth: 100, maxWidth: 100, filter: "agTextColumnFilter" },
            { key: "fullname", width: 70, headerName: this.label("Username"), field: "fullname", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
            { key: "department", width: 70, headerName: this.label("Department"), field: "department", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
            { key: "supervisor", width: 70, headerName: this.label("Supervisor"), field: "supervisor", sortable: true, filter: true, enableRowGroup: true, suppressHeaderMenuButton: true, filter: "agTextColumnFilter" },
            { key: "amount", width: 100, minWidth: 100, maxWidth: 100, headerName: this.label("Amount"), field: "amount", sortable: true, filter: false, enableRowGroup: false, suppressHeaderMenuButton: true, filter: "agTextColumnFilter", type: 'rightAligned', valueFormatter: this.nrFormatter },
        ]

        return cols;
    }

    onGridReady = (params) => {
        this.gridApi = params.api;


        if (this.props.gridfilterstate) {
            this.gridApi.applyColumnState({ state: this.props.gridfilterstate.columnState, applyOrder: true });
            this.gridApi.setFilterModel(this.props.gridfilterstate.filterModel);
        }
    };
    deselectAll = () => {
        if (this.gridApi) {
            this.gridApi.deselectAll()
        }
    }

    //#region Grid/Button handlers
    handleChangeYear = (value) => {
        this.props.setSelectedYear(value);
        this.props.loadMyReports(value);
    }
    onCreateNewReportClicked = () => {
        console.log('yep');
        this.setState({
            currentEditEntity: {
                idUser: this.props.currentuser.idUser,
                displayname: this.props.currentuser.displayname,
                idReportType: common.REPORT_TYPES.IReceive,
                governmentCompany: false
            },
            addNewReportFormVisible: true,
        });
    }
    onDeleteReportLineClicked = async () => {
        if (this.state.selectedIdReport > 0) {
            if (window.confirm(this.label("DeleteConfirm"))) {
                await this.props.deleteReport(this.state.selectedIdReport)
                this.refreshClicked();
            }
        }
    }
    onDoubleClick = async (dataitem) => {
        this.props.history.push(`/app/reports/${dataitem.idReport}`)
    }
    onSelect = async (dataitem) => {
        this.setState({
            selectedIdReport: dataitem.idReport,
        });
    }

    //#endregion

    //#region Form handlers

    handleCancelForm = (e) => {
        this.setState({
            addNewReportFormVisible: false,
            currentEditEntity: {},
        });
        this.deselectAll();
    }

    handleAddNewReport = async (values, file, submitToWorkflow) => {
        const newid = await this.props.createNewReport(values);

        if (newid !== 0) {
            message.success(this.label("SuccesAndUploading"));
            if (file != undefined) {
                await this.props.uploadReportFile(file, newid);
                message.success(this.label("UploadSucces"));
            }
            
            if (submitToWorkflow) {
                await this.props.submitNewReportForApproval(newid)
            }

            this.setState({
                addNewReportFormVisible: false,
                currentEditEntity: {},
            });
            this.refreshClicked();
        } else {
            message.error(this.label("ErrorCreatingReport"));
        }
    }

    //#endregion

    render() {
        const loading = this.props.loadingReports;
        const menuHeight = 45
        const gridHeight = this.props.contentHeight - menuHeight;
        const columnDefinitions = this.getGridCols();

        return (
            <div className='disputes'>
                <Row className='main-toolbar' style={{ height: menuHeight }} justify='start' align='middle' gutter={8}>
                    <Col span={24} >
                        <span className='module-title'>{this.label("MyReports")}</span>
                        <span style={{ margin: 5, marginLeft: 25 }}>{this.label("Year")}</span>
                        <Select onChange={this.handleChangeYear} value={this.props.selectedYear}>
                            {
                                this.props.picklists.years ? this.props.picklists.years.map(o => <Select.Option key={o.id} value={o.id}>{o.name}</Select.Option>) : null
                            }
                        </Select>
                        <Button type="primary" icon={<FileAddOutlined />} onClick={this.onCreateNewReportClicked} style={{ margin: 5 }} >{this.label("NewReport")}</Button>
                        <Button icon={<DeleteOutlined />} onClick={this.onDeleteReportLineClicked} style={{ margin: 5, marginLeft: 15 }} >{this.label("DeleteReport")}</Button>
                    </Col>
                </Row>
                {loading ? (
                    <div className="loader-content" >
                        <Spin size="large" />
                        <p>{this.label("Loading")}</p>
                    </div>
                ) : (
                    <>
                        <AgGridWithState height={gridHeight} ShowGroupPanel={true}
                            lang={this.props.curLanguage}
                            onReady={this.onGridReady}
                            onItemSelected={this.onSelect}
                            onItemDoubleClicked={this.onDoubleClick}
                            columnDefinitions={columnDefinitions}
                            data={this.props.myreports}
                            onRefresh={this.refreshClicked}
                            labels={this.props.labels}
                            frameworkComponents={{
                                'rendererBoolean': RendererBoolean, 'rendererStatus': RendererStatus
                            }}
                        >
                        </AgGridWithState>
                    </>
                )}

                <Modal title={this.label("AddNewReportModalTitle")} width='60%' destroyOnHidden={true}
                    open={this.state.addNewReportFormVisible}
                    footer={null}
                    onCancel={this.handleCancelForm}
                >
                    <NewReportForm datacontext={this.state.currentEditEntity} onCancel={this.handleCancelForm} onSave={this.handleAddNewReport} />
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        loadingReports: state[constants.NAME].loadingReports,
        myreports: state[constants.NAME].myreports,
        selectedYear: state[constants.NAME].selectedYear,
        contentHeight: state[uistate.constants.NAME].contentheight,
        labels: uistate.selectors.uiLabels(state),
        curLanguage: uistate.selectors.curLanguage(state),
        currentuser: state[currentuser.constants.NAME],
        picklists: globalappstate.selectors.allPicklists(state),
        gridfilterstate: state[uistate.constants.NAME].gridfilterstate['MyReportsGrid'],
    };
}

export default connect(mapStateToProps,
    {
        loadMyReports,
        createNewReport,
        setSelectedYear,
        deleteReport,
        uploadReportFile,
        submitNewReportForApproval,
        saveGridFilters: uistate.actions.saveGridFilters
    })(MyReportsGrid);